import PatientList from "../components/PatientList/PatientList";

function Reports(props) {
  return (
    <div className="col-12">
      <PatientList {...props} />
    </div>
  );
}

export default Reports;
